// Quote request + spare parts (US Packing Equipment).
// - Builds the "Request a Quote" link: machine, selected size and the ticked spare parts.
// - Shows the spare parts block / replacement parts table of the selected size.
// - Cart mode (later): adds the ticked parts to the cart after the machine was added.
(function () {
  if (window.uspQuoteInit) return;
  window.uspQuoteInit = true;

  function variantId(root) {
    var input = root.querySelector('variant-picker input:checked[data-variant-id]');
    if (input) return input.getAttribute('data-variant-id');
    var option = root.querySelector('variant-picker select option:checked[data-variant-id]');
    if (option) return option.getAttribute('data-variant-id');
    var json = root.querySelector('variant-picker script[type="application/json"]');
    try {
      var v = JSON.parse(json.textContent);
      if (v && v.id) return String(v.id);
    } catch (e) {}
    return new URLSearchParams(window.location.search).get('variant') || '';
  }

  function selectedParts() {
    var out = [];
    document
      .querySelectorAll('[data-usp-parts] [data-usp-parts-variant]:not([hidden]) :is(.usp-parts__item, .usp-rparts__row)')
      .forEach(function (item) {
        var box = item.querySelector('.usp-parts__check, .usp-rparts__check');
        if (!box || !box.checked) return;
        var qty = parseInt(item.querySelector('.usp-parts__qty, .usp-rparts__qty').value, 10);
        if (!(qty > 0)) qty = 1;
        out.push({
          qty: Math.min(qty, 99),
          label: box.getAttribute('data-part-label'),
          variant: box.getAttribute('data-part-variant'),
        });
      });
    return out;
  }

  // ---------- Factory options ("Upgrades", snippets/usp-factory-options.liquid) ----------
  var optionState = {}; // code -> true (checkbox) or number of units (qty options)

  function money(n) {
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function readJson(el) {
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }
  function priceFor(opt, size) {
    if (typeof opt.price === 'number') return opt.price;
    if (opt.price && Object.prototype.hasOwnProperty.call(opt.price, size)) return opt.price[size];
    return undefined; // not available for this size
  }

  // Renders the options for the selected size; returns { lines, sum, total } of the selected options.
  function renderOptions(root, vid) {
    var box = root.querySelector('[data-usp-options]');
    if (!box) return null;
    var data = readJson(box.querySelector('[data-usp-options-data]'));
    var variants = readJson(box.querySelector('[data-usp-options-variants]')) || {};
    if (!data || !data.options) return null;
    var variant = variants[vid] || variants[Object.keys(variants)[0]];
    if (!variant) return null;
    var size = variant.title;

    // options included by another selected option (e.g. BAS 25"–35" and CE include 220PX)
    var includedBy = {};
    data.options.forEach(function (o) {
      var p = priceFor(o, size);
      if (p === undefined || p === 'included' || !optionState[o.code] || !o.includes) return;
      (o.includes[size] || []).forEach(function (code) {
        includedBy[code] = o.code;
      });
    });

    // Ripack "Add accessories" (custom.addons) use the same block: separate items, listed with part number and name
    var acc = data.kind === 'accessories';
    var label = function (o) { return acc ? o.code + ' ' + o.name : o.code; };
    var esc = function (t) { return String(t).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); };

    var list = box.querySelector('[data-usp-options-list]');
    var html = '';
    var lines = [];
    var sum = 0;
    data.options.forEach(function (o, i) {
      var p = priceFor(o, size);
      if (p === undefined) return;
      var id = 'usp-opt-' + i;
      var more = o.url ? ' <a class="usp-options__link" href="' + esc(o.url) + '" target="_blank" rel="noopener">Details</a>' : '';
      var info = o.info || more ? '<span class="usp-options__info">' + (o.info || '') + more + '</span>' : '';
      if (p === 'included' || includedBy[o.code]) {
        var why = p === 'included' ? 'Included' : 'Included with ' + includedBy[o.code];
        html +=
          '<li class="usp-options__item is-included"><span class="usp-options__check" aria-hidden="true">✓</span>' +
          '<span class="usp-options__text"><span class="usp-options__name">' + o.name + '</span>' + info + '</span>' +
          '<span class="usp-options__price">' + why + '</span></li>';
        if (p !== 'included') lines.push(o.code + ' (included with ' + includedBy[o.code] + ')');
        return;
      }
      if (o.qty && o.qty.input) {
        // consumables: free quantity field
        var q = optionState[o.code] || 0;
        html +=
          '<li class="usp-options__item usp-options__item--qty' + (q ? ' is-on' : '') + '"><label class="usp-options__text" for="' + id + '"><span class="usp-options__name">' + o.name + '</span>' +
          '<span class="usp-options__info">' + money(p) + ' each' + (o.info ? '. ' + o.info : '') + more + '</span></label>' +
          '<input type="number" class="usp-options__qty usp-options__qty--input" id="' + id + '" data-usp-option="' + esc(o.code) + '" min="0" max="99" step="1" inputmode="numeric" value="' + q + '" aria-label="Quantity ' + esc(o.name) + '"></li>';
        if (q) {
          sum += q * p;
          lines.push(q + 'x ' + label(o) + ' (' + money(q * p) + ')');
        }
        return;
      }
      if (o.qty) {
        var n = optionState[o.code] || 0;
        var sel = '<option value="0"' + (n ? '' : ' selected') + '>None</option>';
        for (var k = o.qty.min; k <= o.qty.max; k++) {
          sel += '<option value="' + k + '"' + (n === k ? ' selected' : '') + '>' + k + ' ' + o.qty.unit + ' – ' + money(k * p) + '</option>';
        }
        html +=
          '<li class="usp-options__item usp-options__item--qty"><label class="usp-options__text" for="' + id + '"><span class="usp-options__name">' + o.name + '</span>' +
          '<span class="usp-options__info">' + money(p) + ' per ' + o.qty.unit.replace(/s$/, '') + (o.info ? '. ' + o.info : '') + '</span></label>' +
          '<select class="usp-options__qty" id="' + id + '" data-usp-option="' + o.code + '">' + sel + '</select></li>';
        if (n) {
          sum += n * p;
          lines.push(o.code + ' (' + n + ' ' + o.qty.unit + ', ' + money(n * p) + ')');
        }
        return;
      }
      var on = !!optionState[o.code];
      html +=
        '<li class="usp-options__item' + (on ? ' is-on' : '') + '"><input type="checkbox" class="usp-options__box" id="' + id + '" data-usp-option="' + esc(o.code) + '"' + (on ? ' checked' : '') + '>' +
        '<label class="usp-options__text" for="' + id + '"><span class="usp-options__name">' + o.name + '</span>' + info + '</label>' +
        '<span class="usp-options__price">+ ' + money(p) + '</span></li>';
      if (on) {
        sum += p;
        lines.push(label(o) + ' (' + money(p) + ')');
      }
    });
    var focusedId = document.activeElement && list.contains(document.activeElement) ? document.activeElement.id : null;
    list.innerHTML = html;
    // long accessory lists (Ripack 3000: 23 items) start collapsed to 6; selected items stay visible
    var count = list.children.length;
    var more = box.querySelector('[data-usp-options-more]');
    if (acc && count > 6 && box.getAttribute('data-expanded') !== 'true') {
      list.classList.add('is-collapsed');
      if (!more) {
        more = document.createElement('button');
        more.type = 'button';
        more.className = 'usp-options__more';
        more.setAttribute('data-usp-options-more', '');
        more.addEventListener('click', function () {
          box.setAttribute('data-expanded', 'true');
          list.classList.remove('is-collapsed');
          more.remove();
        });
        list.insertAdjacentElement('afterend', more);
      }
      more.textContent = 'Show all ' + count + ' accessories';
    } else {
      list.classList.remove('is-collapsed');
      if (more) more.remove();
    }
    // no option available for this size (e.g. Turbopack 800): hide the whole block
    box.style.display = html ? '' : 'none';
    // also the theme block around it, so no empty gap remains
    var wrap = box.parentElement;
    if (wrap && wrap.children.length === 1 && !wrap.matches('main, form, product-form')) wrap.style.display = html ? '' : 'none';
    if (focusedId && document.getElementById(focusedId)) document.getElementById(focusedId).focus();

    var machine = variant.price / 100;
    var chosen = sum > 0;
    var notice = box.querySelector('[data-usp-options-notice]');
    if (notice) notice.hidden = !chosen;
    var total = box.querySelector('[data-usp-options-total]');
    total.hidden = !chosen;
    total.querySelector('[data-usp-total-machine]').textContent = money(machine);
    total.querySelector('[data-usp-total-options]').textContent = '+ ' + money(sum);
    total.querySelector('[data-usp-total-sum]').textContent = money(machine + sum);
    return { lines: chosen ? lines : [], sum: sum, total: machine + sum, word: acc ? 'Accessories' : 'Upgrades' };
  }

  function update() {
    document.querySelectorAll('[data-usp-quote]').forEach(function (cta) {
      var root = cta.closest('.shopify-section') || document;
      var vid = variantId(root);
      var opts = renderOptions(root, vid);
      var variants = {};
      try {
        variants = JSON.parse(cta.querySelector('[data-usp-variants]').textContent);
      } catch (e) {}

      // spare parts block and replacement parts table follow the selected size
      document.querySelectorAll('[data-usp-parts-variant]').forEach(function (el) {
        var key = el.getAttribute('data-usp-parts-variant');
        el.hidden = key !== 'all' && vid !== '' && key !== vid;
      });
      document.querySelectorAll('[data-usp-parts]').forEach(function (block) {
        block.hidden = !block.querySelector('[data-usp-parts-variant]:not([hidden])');
      });
      var table = document.getElementById('replacement-parts');
      if (table) table.hidden = !table.querySelector('[data-usp-parts-variant]:not([hidden])');

      // "Selected model" specs box follows the selected model (snippets/usp-variant-specs.liquid)
      document.querySelectorAll('[data-usp-variant-only]').forEach(function (el) {
        if (vid !== '') el.hidden = el.getAttribute('data-usp-variant-only') !== vid;
      });

      // "Model: …" in the line under the title follows the selected size
      var models = {};
      try {
        models = JSON.parse(root.querySelector('[data-usp-models]').textContent);
      } catch (e) {}
      var modelEl = root.querySelector('[data-usp-model]');
      if (modelEl && models[vid]) modelEl.textContent = models[vid];

      var label = cta.getAttribute('data-product-title');
      if (variants[vid]) label += ' – ' + variants[vid];
      if (opts && opts.lines.length) {
        label += ' + ' + opts.word + ': ' + opts.lines.join(', ') + ' = Total ' + money(opts.total);
      }
      selectedParts().forEach(function (p) {
        label += ' + ' + p.qty + 'x ' + p.label;
      });
      // main button and the mobile sticky button carry the same link
      cta.querySelectorAll('.inquiry-cta__button').forEach(function (link) {
        link.href = cta.getAttribute('data-contact-url') + '?product=' + encodeURIComponent(label);
      });
    });
  }

  // Mobile sticky "Request a Quote": visible whenever the main button is off screen (below it on page load,
  // above it after scrolling past), hidden while the main button itself is visible.
  // Horizon scrolls inside .page-wrapper, so scroll events are caught in the capture phase.
  var stickyQueued = false;
  function updateSticky() {
    stickyQueued = false;
    document.querySelectorAll('[data-usp-sticky-quote]').forEach(function (bar) {
      var main = bar.parentElement.querySelector('.inquiry-cta__button:not(.usp-sticky-quote__button)');
      if (!main) return;
      var r = main.getBoundingClientRect();
      var show = r.bottom < 0 || r.top > window.innerHeight;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var link = bar.querySelector('a');
      if (link) link.tabIndex = show ? 0 : -1;
    });
  }
  function queueSticky() {
    if (stickyQueued) return;
    stickyQueued = true;
    window.requestAnimationFrame(updateSticky);
  }
  document.addEventListener('scroll', queueSticky, { capture: true, passive: true });
  window.addEventListener('resize', queueSticky);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (t.hasAttribute('data-usp-option')) {
      var code = t.getAttribute('data-usp-option');
      if (t.type === 'checkbox') optionState[code] = t.checked;
      else optionState[code] = Math.max(0, Math.min(99, parseInt(t.value, 10) || 0));
      update();
    } else if (t.closest('[data-usp-parts]')) {
      // entering a quantity ticks the part
      if (t.classList.contains('usp-parts__qty') || t.classList.contains('usp-rparts__qty')) {
        var box = t.closest('.usp-parts__item, .usp-rparts__row').querySelector('.usp-parts__check, .usp-rparts__check');
        if (box) box.checked = true;
      }
      update();
    } else if (t.closest('variant-picker')) {
      update();
      setTimeout(update, 800);
    }
  });
  document.addEventListener('input', function (e) {
    if (!(e.target instanceof Element)) return;
    if (e.target.classList.contains('usp-options__qty--input')) {
      optionState[e.target.getAttribute('data-usp-option')] = Math.max(0, Math.min(99, parseInt(e.target.value, 10) || 0));
      update();
    } else if (e.target.classList.contains('usp-parts__qty') || e.target.classList.contains('usp-rparts__qty')) update();
  });
  document.addEventListener('shopify:product:select', function () {
    setTimeout(update, 800);
  });

  // Cart mode (for later, when the shop sells): after the machine has been added to the cart,
  // the ticked parts are added too and the cart page opens.
  document.addEventListener('shopify:cart:lines-update', function () {
    var block = document.querySelector('[data-usp-parts][data-mode="cart"]');
    if (!block || block.getAttribute('data-busy') === 'true') return;
    var items = selectedParts().map(function (p) {
      return { id: Number(p.variant), quantity: p.qty };
    });
    if (!items.length) return;
    block.setAttribute('data-busy', 'true');
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    }).finally(function () {
      window.location.href = root + 'cart';
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      update();
      updateSticky();
    });
  } else {
    update();
    updateSticky();
  }
})();
